import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';

const viewportNodePartnership = document.querySelector('.partnerships-logo__container');
let shouldWait = false;

export default function PartnershipCarousel() {
  const options = {
    loop: true,
    align: 'start',
    breakpoints: {
      '(max-width: 768px)': {
        align: 'center',
      },
    },
  };

  const emblaApi = EmblaCarousel(viewportNodePartnership, options, [
    AutoScroll({
      playOnInit: true,
      speed: 0.5,
      stopOnInteraction: false,
      stopOnMouseEnter: window.innerWidth > 767,
      startDelay: 100,
    }),
  ]);

  // It is used to randomly switch the images.
  setInterval(() => {
    if (shouldWait) {
      return;
    }
    shouldWait = true;
    const slidesInView = emblaApi.slidesInView();
    const slidesNotInView = emblaApi.slidesNotInView();
    const slideNodes = emblaApi.slideNodes();

    // Getting random in view and not in view slide.
    const randomInViewIndex = slidesInView[Math.floor(Math.random() * slidesInView.length)];
    const randomNotInViewIndex = slidesNotInView[Math.floor(Math.random() * slidesNotInView.length)];

    const inViewRandomSlide = slideNodes[randomInViewIndex];
    const notInViewRandomSlide = slideNodes[randomNotInViewIndex];

    if (inViewRandomSlide && notInViewRandomSlide) {
      const inViewOldLink = inViewRandomSlide.querySelector('.old-image');
      const inViewNewLink = document.createElement('a');
      inViewNewLink.classList.add('new-image');
      inViewNewLink.setAttribute('href', '');
      inViewRandomSlide.appendChild(inViewNewLink);

      const notInViewOldLink = notInViewRandomSlide.querySelector('.old-image');
      const dummyInViewOldInnerHtml = inViewOldLink.innerHTML;
      const dummyInViewOldHref = inViewOldLink.href;

      if (dummyInViewOldInnerHtml.length) {
        inViewOldLink.classList.remove('show-animation');
        inViewOldLink.classList.add('hide-animation');

        setTimeout(() => {
          inViewOldLink.innerHTML = null;
          inViewOldLink.setAttribute('href', '');
        }, 500);

        inViewNewLink.innerHTML = notInViewOldLink.innerHTML;
        inViewNewLink.setAttribute('href', notInViewOldLink.href);
        inViewNewLink.classList.remove('hide-animation');
        inViewNewLink.classList.add('show-animation');
        notInViewOldLink.innerHTML = dummyInViewOldInnerHtml;
        notInViewOldLink.setAttribute('href', dummyInViewOldHref);

        // after animation is completed putting the new link back to old link to maintain the consistency
        setTimeout(() => {
          inViewOldLink.classList.remove('hide-animation');
          inViewOldLink.classList.remove('show-animation');
          inViewOldLink.innerHTML = inViewNewLink.innerHTML;
          inViewOldLink.setAttribute('href', inViewNewLink.href);

          setTimeout(() => {
            inViewRandomSlide.removeChild(inViewNewLink);
            shouldWait = false;
          }, 1000);
        }, 2000);
      }
    }
  }, 7000);
}
